
import { useState } from 'react';
import { Link } from 'react-router-dom';
import { featuredProducts } from '../../../mocks/products';

export default function FeaturedProducts() {
  const [addedProduct, setAddedProduct] = useState<number | null>(null);

  const handleAddToCart = (e: React.MouseEvent, productId: number) => {
    e.preventDefault();
    e.stopPropagation();
    setAddedProduct(productId);
    setTimeout(() => setAddedProduct(null), 2000);
  };

  return (
    <section className="py-20" style={{ backgroundColor: '#1B2D3E' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl md:text-5xl font-bold mb-4 text-white" style={{ fontFamily: "'Tajawal', sans-serif" }}>
            المنتجات المميزة
          </h2>
          <p className="text-lg max-w-2xl mx-auto text-gray-400">
            اكتشف أفضل المنتجات المختارة بعناية خصيصاً لك
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8" data-product-shop>
          {featuredProducts.map((product) => (
            <div key={product.id} className="group">
              <div className="rounded-2xl overflow-hidden shadow-md hover:shadow-xl transition-all duration-300" style={{ backgroundColor: '#0D1B2A' }}>
                <Link to={`/product/${product.id}`} className="cursor-pointer">
                  <div className="relative aspect-square w-full h-full overflow-hidden" style={{ backgroundColor: '#1B2D3E' }}>
                    <img 
                      src={product.image}
                      alt={product.name}
                      className="w-full h-full object-cover object-top group-hover:scale-110 transition-transform duration-500"
                    />
                    {product.discount && (
                      <div className="absolute top-4 right-4 text-black px-3 py-1 rounded-full text-sm font-bold" style={{ backgroundColor: '#D4A84B' }}>
                        -{product.discount}%
                      </div>
                    )}
                  </div>
                </Link>
                <div className="p-6">
                  <Link to={`/product/${product.id}`} className="cursor-pointer">
                    <h3 className="text-lg font-bold mb-2 line-clamp-2 transition-colors text-white hover:text-[#D4A84B]" style={{ fontFamily: "'Tajawal', sans-serif" }}>
                      {product.name}
                    </h3>
                  </Link>
                  <div className="flex items-center gap-2 mb-3">
                    <div className="flex items-center">
                      {[...Array(5)].map((_, i) => (
                        <div key={i} className="w-4 h-4 flex items-center justify-center">
                          <i className={`ri-star-${i < product.rating ? 'fill' : 'line'} text-sm`} style={{ color: '#D4A84B' }}></i>
                        </div>
                      ))}
                    </div>
                    <span className="text-sm text-gray-400">({product.reviews})</span>
                  </div>
                  <div className="flex items-center gap-3 mb-4">
                    <span className="text-2xl font-bold" style={{ color: '#D4A84B' }}>
                      {product.price} ر.س
                    </span>
                    {product.originalPrice && (
                      <span className="text-lg line-through text-gray-500">
                        {product.originalPrice} ر.س
                      </span>
                    )}
                  </div>
                  <button
                    onClick={(e) => handleAddToCart(e, product.id)}
                    className="w-full py-3 text-black font-semibold rounded-lg transition-all duration-300 flex items-center justify-center gap-2 cursor-pointer whitespace-nowrap"
                    style={{ backgroundColor: '#D4A84B' }}
                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5B95C'}
                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
                  >
                    {addedProduct === product.id ? (
                      <>
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-check-line text-lg"></i>
                        </div>
                        <span>تمت الإضافة</span>
                      </>
                    ) : (
                      <>
                        <div className="w-5 h-5 flex items-center justify-center">
                          <i className="ri-shopping-cart-line text-lg"></i>
                        </div>
                        <span>أضف للسلة</span>
                      </>
                    )}
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link 
            to="/products" 
            className="inline-block px-8 py-4 text-black text-lg font-semibold rounded-lg transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap cursor-pointer"
            style={{ backgroundColor: '#D4A84B' }}
            onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#E5B95C'}
            onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#D4A84B'}
          >
            عرض جميع المنتجات
          </Link>
        </div>
      </div>
    </section>
  );
}
